<template>
  <div>
    <portal-target name="lnPrintButton"></portal-target>
    <div :style="{ fontSize: fonts.font26 + 'px' }"
         class="head">{{ loanHead }}</div>
    <!-- Full width Loan transaction -->
    <div v-if="fonts.percent >= 80 && !printerFriendly"
         class="bCard" :style="{ fontSize: fonts.font12 + 'px' }">
      <div class="groupHeader">
        <span class="clkHead" @click="clkDate" style="width: 12%">{{histLoans.dateHeader}}</span>
        <span class="clkHead" @click="clkDesc" style="width: 40%">{{histLoans.descHeader}}</span>
        <span class="clkHead" @click="clkPay" style="width: 12%">Payment</span>
        <span class="grHead" style="width: 12%">Interest</span>
        <span class="grHead" style="width: 12%">Principal</span>
        <span class="grHead" style="width: 12%">Balance</span>
      </div>
      <div v-if="histLoans.count < 0">
        Requesting Transactions from CU Server...
      </div>
      <div v-if="histLoans.count === 0">
        No Transactions Found
      </div>
      <div v-if="histLoans.count > 0"> <!-- [068] add this compare -->
        <div v-for="lh in histLoans.arr" :key="lh.key">
          <div :style="lh.selectBox">
            <div :style="lh.style" @click="toggleLoan(lh)">
              <div class="groupSection"
                   :style="lh.highlight"
                   @mouseenter="mouseEnter(lh)"
                   @mouseleave="mouseExit(lh)">
                <div class="grCenter" style="width: 12%" v-html="lh.date2"></div>
                <div class="grLeft" style="width: 40%" v-html="lh.descX"></div>
                <div class="grRight" style="width: 12%">{{ lh.$amt }}</div>
                <div class="grRight" style="width: 12%">{{ lh.$fc }}</div>
                <div class="grRight" style="width: 12%">{{ lh.$pri }}</div>
                <div class="grRight" style="width: 12%">{{ lh.$bal }}</div>
              </div>
            </div>
            <div v-show="lh.isActive" @click="toggleLoan(lh)">
              <div :style="lh.style">
                <!-- <b-button-group class="btnGroup">
                  <b-button class="btnDetail" @click="historyDetail(lh)">
                    Request Details: {{lh.file}}-{{lh.tran}}
                  </b-button>
                </b-button-group> -->
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <!-- Minimum width Loan transaction -->
    <div v-if="fonts.percent < 80 && !printerFriendly"
         class="bCard" :style="{ fontSize: fonts.font14 + 'px' }">
      <div class="groupHeader">
        <span class="clkHead" @click="clkDate" style="width: 20%">{{histLoans.dateHeader}}</span>
        <span class="clkHead" @click="clkDesc" style="width: 60%">{{histLoans.descHeader}}</span>
        <!-- <span class="grHead" style="width: 60%">{{fonts.w}}</span> -->
        <span class="clkHead" @click="clkPay" style="width: 20%">Pay/Bal</span>
      </div>
      <div v-for="lh in histLoans.arr" :key="lh.key">
        <div>
          <div :style="lh.style">
            <div class="groupSection"
                 :style="lh.highlight"
                 @mouseenter="mouseEnter(lh)"
                 @mouseleave="mouseExit(lh)">
              <div class="grCenter" style="width: 20%" v-html="lh.date2"></div>
              <div class="grLeft" style="width: 60%" v-html="lh.desc2"></div>
              <div class="grRight" style="width: 20%" v-html="lh.$amtBal"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="printerFriendly">
      <div id="lnPrint">
        <div id="lnPrintHeader">{{ loanHead }}</div>
        <table id="printTable">
          <thead>
          <tr>
            <th class="thItem" style="width: 12%">Date</th>
            <th class="thItem" style="width: 40%">Description</th>
            <th class="thItem" style="width: 12%">Payment</th>
            <th class="thItem" style="width: 12%">Interest</th>
            <th class="thItem" style="width: 12%">Principal</th>
            <th class="thItem" style="width: 12%">Balance</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="lh in histLoans.arr" :key="lh.key">
            <td class="grCenter tdItem" v-html="lh.date2"></td>
            <td class="grLeft tdItem" v-html="lh.descX"></td>
            <td class="grRight tdItem" >{{ lh.$amt }}</td>
            <td class="grRight tdItem" >{{ lh.$fc }}</td>
            <td class="grRight tdItem" >{{ lh.$pri }}</td>
            <td class="grRight tdItem" >{{ lh.$bal }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <portal to="lnPrintButton">
      <button class="btnLnPrint"
              @click="togglePrinterFriendly">
        {{pfText}}
      </button>
      <button
        id="btnPrintStmt"
        v-if="printerFriendly"
        class="btnLnPrint"
        v-print="'#lnPrint'">Print</button>
    </portal>

  </div>
</template>

<script>
export default {
  name: 'z-loanHistory',
  data() {
    return {
      rowHeight: 26,
      printerFriendly: false,
      pfText: 'Printer Friendly',
    };
  },
  watch: {
    HLcc() {
      this.$forceUpdate();
    },
  },
  computed: {
    HLcc() {
      return this.$store.getters.getHLcc;
    },
    history() {
      return this.$store.getters.getHistory;
    },
    histLoans() {
      return this.$store.getters.getHistLoans;
    },
    fonts() {
      return this.$store.getters.getFonts;
    },
    cun() {
      return this.$store.getters.getCuNumber;
    },
    member() {
      return this.$store.getters.getMember;
    },
    loanHead() {
      return `${this.member.acct} Note # ${this.history.note}`;
    },
  },
  methods: {
    // eslint-disable-next-line
    toggleLoan(lh) {
      const lnInfo = {};
      lnInfo.type = 'L';
      lnInfo.file = lh.file;
      lnInfo.tran = lh.tran;
      lnInfo.note = lh.note;
      lnInfo.isActive = !lh.isActive;
      this.$store.commit('setActiveLoanHistory', lnInfo);
      this.$forceUpdate();
      let myShow = 'hide';
      if (lh.isActive) myShow = 'show';
      this.writeDiag(`toggleShare = ${lh.file}-${lh.tran} ${myShow}`);
      this.$store.commit('resetServerTimeout', lnInfo);
    },

    // eslint-disable-next-line
    historyDetail(lh) {
      this.writeDiag(`Clicked Loan history Detail # ${lh.note} ${lh.file}-${lh.tran}`);
      const lnInfo = {};
      lnInfo.note = lh.note;
      lnInfo.file = lh.file;
      lnInfo.tran = lh.tran;
      this.$store.commit('requestLoanDetail', lnInfo);
      this.$forceUpdate();
    },
    mouseEnter(lh) {
      // this.writeDiag(`Enter Loan history Line # ${lh.key}`);
      const lhInfo = {};
      lhInfo.key = lh.key;
      lhInfo.style = 'background-color: green; color: white';
      this.$store.commit('setLoanHistHighlight', lhInfo);
    },
    mouseExit(lh) {
      // this.writeDiag(`Exit Loan history Line # ${lh.key}`);
      const lhInfo = {};
      lhInfo.key = lh.key;
      lhInfo.style = lh.style;
      this.$store.commit('setLoanHistHighlight', lhInfo);
    },
    clkDate() {
      // utl.diag('Clicked Date Header');
      this.$store.commit('sortLoanDate');
    },
    clkDesc() {
      // utl.diag('Clicked Description Header');
      this.$store.commit('sortLoanDesc');
    },
    clkPay() {
      // utl.diag('Clicked Withdrawal Header');
      this.$store.commit('sortLoanPay');
    },
    writeDiag(message) {
      this.$store.commit('putDiag', message);
    },
    togglePrinterFriendly() {
      this.printerFriendly = !this.printerFriendly;
      if (this.printerFriendly) {
        this.pfText = 'Interactive View';
      } else {
        this.pfText = 'Printer Friendly';
      }
    },
  },
};
</script>

<style scoped>
  .head {
    /* position: relative; */ /* setting this causes back-button to be ignored*/
    text-align: center;
    padding-right: 4px;
    z-index: 1;
    font-weight: bold;
    color: black;
    border: solid 1px black;
  }
  .bCard {
    padding: 4px;
    margin: 0px;
    width: 100%;
    border: solid 1px black;
  }
  .btnCollapse {
    display: inline-block;
    padding: 0px;
    width: 100%;
    background-color: lightyellow;
    color: black;
    font-weight: bold;
  }
  .groupHeader {
    display: inline-flex;
    padding: 0px;
    width: 100%;
  }
  .groupSection {
    display: inline-flex;
    vertical-align: center;
    vert-align: middle;
    padding: 0px;
    width: 100%;
    cursor: pointer;
  }
  .grHead {
    padding: 0px;
    /* height: 26px; */
    background-color: floralwhite;
    color: black;
    font-weight: bold;
    border: solid 1px black;
  }
  .clkHead {
    padding: 0px;
    /* height: 26px; */
    background-color: floralwhite;
    color: black;
    font-weight: bold;
    border: solid 1px black;
    cursor: pointer;
  }

  .grPrime {
    /* display: inline-flex; */
    text-align: left;
    padding: 0px;
    padding-left: 4px;
    background-color: transparent;
    font-weight: bold;
    text-decoration: underline;
    border: dotted 1px lightgray;
  }
  .grLeft {
    text-wrap: avoid;
    text-align: left;
    padding: 0px;
    padding-left: 4px;
    background-color: transparent;
    font-weight: bold;
    border: dotted 1px lightgray;
  }
  .grRight {
    text-align: right;
    padding: 0px;
    padding-right: 4px;
    background-color: transparent;
    font-weight: bold;
    border: dotted 1px lightgray;
  }
  .btnDetail {
    background-color: green;
    padding: 1px;
    margin: 4px;
    font-size: 12px;
    height: 20px;
  }
  .btnLnPrint {
    background-color: lime;
    color: black;
    font-weight: bold;
  }
  #lnPrint {
    position: relative;
    width: 100%;
    border: solid 2px black;
    background: white;
    font-size: 20px;
    padding-bottom: 4px;
  }
  #lnPrintHeader {
    font-size: 24px;
    font-weight: bold;
    color: black;
    padding: 8px;
    text-align: center;
  }
  #printTable {
    margin: auto;
  }
  .thItem {
    border: solid 1px black;
    background-color: lightgrey;
    font-weight: bold;
    color: black;
    padding: 4px;
    text-align: center;
  }
  .tdItem {
    border: solid 1px black;
    font-weight: bold;
    font-size: 16px;
    color: black;
    padding: 0px 4px; /* Padding TOP/BOTTOM = 0 / Padding Left/Right = 4 */
  }

</style>



// WEBPACK FOOTER //
// src/components/z-loanHistory.vue